import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getRemindersListFetchSuccess, getRemindersListFetchFailure } from './reducer';
import { RemindersListParamsType, RemindersListResType } from 'src/types/remindersList';

const getRemindersListFetchRequest = async (data: RemindersListParamsType) => {
    const { typeItem, idItem } = data;
    const arrQuery = [];
    if (typeItem) {
        arrQuery.push(`typeItem=${typeItem}`);
    }
    if (idItem) {
        arrQuery.push(`idItem=${idItem}`);
    }
    let url = 'api/secure/reminders';
    if (arrQuery.length) {
        url += `?${arrQuery.join('&')}`;
    }
    const res = await api('get', url);
    return res.data.data;
};

function* getRemindersListFetch(action: { type: string; payload: RemindersListParamsType }) {
    try {
        const response: RemindersListResType = yield call((): any => getRemindersListFetchRequest(action.payload));
        yield put(getRemindersListFetchSuccess(response));
    } catch (error) {
        yield put(getRemindersListFetchFailure({ error }));
    }
}

export function* getRemindersListFetchWatch() {
    yield takeEvery('remindersList/getRemindersListFetch', getRemindersListFetch);
}
